import React from 'react';
import { useGetNoPageListData } from '../../../../base/components/customized/CustomizedNoPageList';
import resourceSlug from '../../../../constant/resource-slug';
import MakePaymentButton from '../MakePaymentButton';

const PaymentButton = ({ invoiceId }) => {
  const { refetchListData } = useGetNoPageListData(resourceSlug.INVOICE);

  return (
    <MakePaymentButton
      invoiceIds={[invoiceId]}
      onSuccess={() => {
        refetchListData();
      }}
    />
  );
};

export default PaymentButton;
